<template>
  <AppLayout>
    <div class="page">
      <div class="title-row">
        <span class="badge">📈</span>
        <h1 class="title">免费数据分析在线</h1>
      </div>

      <div class="grid">
        <button class="tool-card" type="button" @click="goSem">
          <div class="tool-card-top">
            <div class="tool-icon">AI</div>
            <div class="tool-name">SEM填色和粒径分析</div>
          </div>
          <div class="tool-desc">导入SEM图片 → 标尺识别 → AI分割填色 → 粒径统计导出。</div>
        </button>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from '../layouts/AppLayout.vue';

export default {
  name: 'AnalysisHome',
  components: { AppLayout },
  methods: {
    goSem() {
      this.$router.push({ name: 'semLanding' });
    },
  },
};
</script>

<style scoped>
.page {
  min-height: calc(100vh - 56px - 16px - 20px - 18px - 20px);
}

.title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.badge {
  width: 28px;
  height: 28px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(16, 185, 200, 0.15);
}

.title {
  margin: 0;
  font-size: 18px;
  color: var(--rw-text);
}

.grid {
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
}

.tool-card {
  text-align: left;
  border: 1px solid rgba(148, 163, 184, 0.32);
  background: var(--rw-white);
  border-radius: 14px;
  padding: 12px 12px 11px;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

.tool-card:hover {
  border-color: rgba(16, 185, 200, 0.55);
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);
}

.tool-card-top {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tool-icon {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background: linear-gradient(145deg, var(--rw-primary-2), var(--rw-primary-3));
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13px;
  box-shadow: 0 8px 18px rgba(34, 193, 195, 0.45);
}

.tool-name {
  font-size: 12px;
  font-weight: 600;
  color: var(--rw-text);
}

.tool-desc {
  margin-top: 8px;
  font-size: 11px;
  color: var(--rw-muted);
  line-height: 1.35;
}

@media (max-width: 960px) {
  .grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>

